import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';

export default function FixaceForm(props) {
  const {
    fiveYears,
    threeYears,
    tenYears,
    fiveteenYears,
    jine,
    onChecked,
    title,
  } = props;

  return (
    <React.Fragment>
      <p>
        {title}
      </p>
      <FormGroup style={{ flexDirection: 'row', justifyContent: 'space-around' }}>
        <FormControlLabel
          control={(
            <Checkbox
              checked={threeYears}
              onChange={onChecked('threeYears')}
              value='3'
            />
          )}
          label='3 roky'
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={fiveYears}
              onChange={onChecked('fiveYears')}
              value='5'
            />
          )}
          label='5 let'
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={tenYears}
              onChange={onChecked('tenYears')}
              value='10'
            />
          )}
          label='10 let'
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={fiveteenYears}
              onChange={onChecked('fiveteenYears')}
              value='15'
            />
          )}
          label='15 let'
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={jine}
              onChange={onChecked('jine')}
              value='jine'
            />
          )}
          label='jiné'
        />
      </FormGroup>
    </React.Fragment>
  );
}

FixaceForm.propTypes = {
  fiveteenYears: PropTypes.bool.isRequired,
  fiveYears: PropTypes.bool.isRequired,
  jine: PropTypes.bool.isRequired,
  onChecked: PropTypes.func.isRequired,
  tenYears: PropTypes.bool.isRequired,
  threeYears: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};
